import { ReactElement } from 'react';

const Content = ({ children }: { children?: ReactElement }) => (
    <main className="automate-content">
        <div className="content-wrapper">{children}</div>
    </main>
);

export default Content;
